import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, HandCoins, UserPlus, Users, ArrowRight, Heart, CheckCircle2, XCircle, FileText } from 'lucide-react';
import { SectionHeader } from './AdminShell';
import { ViewsChart, DonationsChart } from './OverviewCharts';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inr = (n) => `₹${(n || 0).toLocaleString('en-IN')}`;
const FEED_ICON = { donation: Heart, application: FileText, approved: CheckCircle2, rejected: XCircle };

const StatCard = ({ icon: Icon, label, value, sub, testid, onClick, tone = 'gold' }) => {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag type={onClick ? 'button' : undefined} className={`jbss-adm-stat tone-${tone} ${onClick ? 'is-link' : ''}`} onClick={onClick} data-testid={testid}>
      <span className="jbss-adm-stat-icon"><Icon size={18} /></span>
      <span className="jbss-adm-stat-label">{label}</span>
      <span className="jbss-adm-stat-value">{value}</span>
      {sub && <span className="jbss-adm-stat-sub">{sub}</span>}
    </Tag>
  );
};

const ChartCard = ({ title, hint, testid, children }) => (
  <div className="jbss-adm-card" data-testid={testid}>
    <div className="jbss-adm-card-head"><h3>{title}</h3><span>{hint}</span></div>
    <div className="jbss-adm-chart">{children}</div>
  </div>
);

export const OverviewSection = ({ token, onUnauthorized, onNavigate }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/overview`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch((e) => { if (e?.response?.status === 401) onUnauthorized(); });
  }, [token, onUnauthorized]);

  const v = data?.views; const d = data?.donations;
  const dash = '—';
  return (
    <>
      <SectionHeader title="Overview" subtitle="A quick look at how the Sangha is doing." />
      <div className="jbss-adm-stats" data-testid="admin-visit-stats">
        <StatCard icon={Eye} label="Views today" value={v ? v.today : dash} sub={v ? `${v.month} this month · ${v.total} all time` : ''} testid="admin-stat-views" tone="navy" />
        <StatCard icon={HandCoins} label="Donations raised" value={d ? inr(d.amount) : dash} sub={d ? `${inr(d.month_amount)} this month · ${d.count} gifts` : ''} testid="admin-stat-donations" onClick={() => onNavigate('donations')} />
        <StatCard icon={UserPlus} label="Pending applications" value={data ? data.pending_applications : dash} sub="Tap to review" testid="admin-stat-pending-applications" onClick={() => onNavigate('applications')} tone="navy" />
        <StatCard icon={Users} label="Approved members" value={data ? data.approved_members : dash} sub="Joined via the website" testid="admin-stat-members" onClick={() => onNavigate('members')} />
      </div>
      <div className="jbss-adm-grid-2">
        <ChartCard title="Website views" hint="Last 30 days" testid="admin-chart-views">{data && <ViewsChart data={data.series} />}</ChartCard>
        <ChartCard title="Donations" hint="Last 30 days" testid="admin-chart-donations">{data && <DonationsChart data={data.series} />}</ChartCard>
      </div>
      <div className="jbss-adm-card" data-testid="admin-recent-activity-feed">
        <div className="jbss-adm-card-head"><h3>Recent activity</h3>
          <button type="button" className="jbss-adm-link" onClick={() => onNavigate('applications')}>Applications <ArrowRight size={14} /></button>
        </div>
        {data && data.recent.length === 0 && <p className="jbss-adm-empty">No activity yet. Donations and membership applications will appear here.</p>}
        <ul className="jbss-adm-feed">
          {data?.recent.map((r, i) => {
            const Icon = FEED_ICON[r.type] || FileText;
            return (
              <li key={`${r.at}-${i}`} className={`feed-${r.type}`}>
                <span className="jbss-adm-feed-icon"><Icon size={15} /></span>
                <span className="jbss-adm-feed-text">{r.title}</span>
                <time>{new Date(r.at).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</time>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
